import { Row } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';
import { useNavigation } from 'app/hooks/navigation';
import { useLogoutRoutine } from 'app/hooks/use-logout-routine';
import { Event, track } from 'app/lib/analytics';
import { storage, StorageKey } from 'app/lib/storage';
import { navigationRef } from 'app/lib/root-navigation';
import { useDeleteIdentity } from 'app/network/identity';
import { ListingType } from 'app/types/listing';
import { useUISize } from 'app/utils/web-helpers';
import { useTranslation } from 'react-i18next';
import { Platform } from 'react-native';
import { IconPower } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';

function LogoutButton() {
  const logoutRoutine = useLogoutRoutine();
  const navigation = useNavigation<'profile-overview'>();
  const { t } = useTranslation('profile-overview');
  const { isLargeUI } = useUISize();

  async function completeLogout() {
    const currentUserId = await storage.readString(StorageKey.CurrentUserId);
    track(Event.UserInitiatedLogout, { source: 'logout', userId: currentUserId ?? 'null' });
    await logoutRoutine();

    if (Platform.OS === 'web' && navigationRef.isReady()) {
      navigationRef.navigate(
        'main',
        {
          screen: 'billboard',
          params: { screen: 'all-listings', params: { activeTab: ListingType.offer, type: ListingType.offer } },
        },
        { pop: true },
      );
      return;
    }

    navigation.reset({ routes: [{ name: isLargeUI ? 'onboardingIntro' : 'presentPartageClub' }] });
  }

  const { mutate: deleteIdentity, isPending } = useDeleteIdentity({
    onSuccess: completeLogout,
    onError: completeLogout,
  });

  const onPressLogout = () => deleteIdentity();

  return (
    <Button
      alignItems="center"
      flexDirection="row"
      justifyContent="center"
      loading={isPending}
      marginTop="spacing.general.x8"
      onPress={onPressLogout}
      testID="logout-button"
      variant="secondary"
    >
      <Row alignItems="center" gap="spacing.general.x2">
        <Text variant="bodyBase">{t('logoutButtonLabel')}</Text>
        <IconPower strokeWidth={ICON_STROKE_WIDTH} size={24} />
      </Row>
    </Button>
  );
}

export default LogoutButton;
